var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoThumbnail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 286,
    height: 178,
    viewBox: "0 0 286 178",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#ebebeb;}.c{fill:#009de0;}.d{fill:#f0f0f0;}.e{fill:#bcbcbc;}.f{fill:none;stroke:#bcbcbc;stroke-linecap:round;stroke-width:2px;}.g{fill:#909090;}.h{fill:#009ce3;}.i{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 286,
    height: 178,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "matrix(1, 0, 0, 1, -9, -6)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 268,
    height: 160,
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 268,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 44,
    height: 145,
    transform: "translate(0 15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M27.531,1.668A1.361,1.361,0,0,1,28.975.288,1.242,1.242,0,0,1,29.842.6a.312.312,0,0,1,.116.244.319.319,0,0,1-.319.32.331.331,0,0,1-.221-.084A.642.642,0,0,0,28.975.9a.737.737,0,0,0-.744.772.767.767,0,0,0,1.237.612V2.072h-.348a.3.3,0,0,1-.288-.3.31.31,0,0,1,.288-.308h.728a.307.307,0,0,1,.308.316v.48a.523.523,0,0,1-.192.444,1.522,1.522,0,0,1-.988.34A1.361,1.361,0,0,1,27.531,1.668Zm-22.917,0A1.362,1.362,0,0,1,6.059.288,1.242,1.242,0,0,1,6.926.6a.312.312,0,0,1,.116.244.319.319,0,0,1-.319.32A.329.329,0,0,1,6.5,1.08.642.642,0,0,0,6.059.9a.737.737,0,0,0-.744.772.737.737,0,0,0,.744.772.73.73,0,0,0,.491-.16V2.072H6.2a.3.3,0,0,1-.288-.3A.31.31,0,0,1,6.2,1.468h.728a.307.307,0,0,1,.308.316v.48a.523.523,0,0,1-.192.444,1.522,1.522,0,0,1-.988.34A1.362,1.362,0,0,1,4.614,1.668ZM34.627,2.856,33.6,1.388v1.3a.344.344,0,1,1-.688,0V.748A.455.455,0,0,1,33.367.3a.447.447,0,0,1,.368.2L34.7,1.868V.644a.346.346,0,1,1,.692,0V2.615a.422.422,0,0,1-.768.24Zm-8.208,0L25.394,1.388v1.3a.344.344,0,1,1-.688,0V.748A.455.455,0,0,1,25.159.3a.447.447,0,0,1,.368.2l.967,1.376V.644a.346.346,0,1,1,.692,0V2.615a.422.422,0,0,1-.768.24Zm-2.88-.168V.644a.344.344,0,1,1,.688,0V2.687a.344.344,0,1,1-.688,0Zm-1.248.168L21.267,1.388v1.3a.344.344,0,1,1-.688,0V.748A.455.455,0,0,1,21.03.3a.447.447,0,0,1,.368.2l.968,1.376V.644a.346.346,0,1,1,.692,0V2.615a.423.423,0,0,1-.769.24Zm-2.668.068L18.842,2l-.192.22v.464a.344.344,0,1,1-.688,0V.644a.344.344,0,1,1,.688,0v.784L19.562.4A.314.314,0,0,1,19.8.3a.327.327,0,0,1,.319.324.313.313,0,0,1-.076.212l-.712.756.792.9A.33.33,0,0,1,20.2,2.7a.333.333,0,0,1-.328.336A.33.33,0,0,1,19.623,2.923Zm-2.644-.131L16.9,2.563h-1.1l-.076.229a.346.346,0,0,1-.676-.1.3.3,0,0,1,.024-.12l.708-1.88A.61.61,0,0,1,16.355.3a.6.6,0,0,1,.563.392l.713,1.88a.41.41,0,0,1,.023.12.346.346,0,0,1-.676.1ZM16,1.984h.7L16.355.932Zm-2.749.66L12.55.788A.493.493,0,0,1,12.526.66.366.366,0,0,1,12.891.3a.372.372,0,0,1,.344.248l.584,1.712L14.406.544A.369.369,0,0,1,14.751.3a.366.366,0,0,1,.364.365.363.363,0,0,1-.028.128l-.7,1.856a.6.6,0,0,1-1.132,0Zm-9.388.148-.076-.229h-1.1l-.076.229a.346.346,0,0,1-.677-.1.3.3,0,0,1,.024-.12L2.675.688A.611.611,0,0,1,3.243.3a.6.6,0,0,1,.564.392l.712,1.88a.41.41,0,0,1,.023.12.346.346,0,0,1-.676.1Zm-.976-.808h.7L3.243.932ZM30.922,3a.327.327,0,0,1-.364-.365V.7a.327.327,0,0,1,.364-.364h1.337a.29.29,0,0,1,0,.581H31.246v.444h.985a.292.292,0,0,1,0,.584h-.985v.48h1.013a.29.29,0,0,1,.288.288A.293.293,0,0,1,32.259,3Zm-20.2,0a.327.327,0,0,1-.364-.365V.7a.327.327,0,0,1,.364-.364h1.337a.29.29,0,0,1,0,.581H11.05v.444h.985a.292.292,0,0,1,0,.584H11.05v.48h1.012a.29.29,0,0,1,.288.288A.293.293,0,0,1,12.063,3ZM8.006,3a.327.327,0,0,1-.364-.365V.7A.327.327,0,0,1,8.006.331H9.155a.7.7,0,0,1,.779.68.6.6,0,0,1-.455.612.639.639,0,0,1,.508.652A.71.71,0,0,1,9.2,3Zm.324-.572h.692a.239.239,0,0,0,.264-.244.246.246,0,0,0-.264-.252H8.33Zm0-1.064H9a.226.226,0,0,0,.237-.232A.223.223,0,0,0,9,.9H8.33ZM.363,3A.328.328,0,0,1,0,2.635V.644A.348.348,0,0,1,.343.3.348.348,0,0,1,.687.644V2.4h.8a.3.3,0,1,1,0,.6Z",
    transform: "translate(2.997 3.592)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M26.419,42.215a.164.164,0,0,1-.173-.178V40.793a.173.173,0,1,1,.347,0v1.1h.651a.159.159,0,0,1,0,.318Zm-1.617,0a.164.164,0,0,1-.173-.178V40.793a.173.173,0,1,1,.346,0v1.1h.649a.159.159,0,0,1,0,.318Zm-10.473-1.41a.161.161,0,0,1,.17-.178h.554a.64.64,0,0,1,.464.161.508.508,0,0,1,.136.364v0a.487.487,0,0,1-.318.484l.24.29a.2.2,0,0,1,.059.131.176.176,0,0,1-.177.168.191.191,0,0,1-.161-.092l-.34-.43h-.28v.343a.173.173,0,1,1-.347,0Zm6.909-.178a.576.576,0,0,1,.416.143.391.391,0,0,1-.1.615.388.388,0,0,1,.3.391c0,.3-.236.44-.595.44h-.581a.164.164,0,0,1-.173-.178V40.805a.164.164,0,0,1,.173-.178ZM19.819,42.05a.173.173,0,1,1-.346,0v-.788l-.306.472a.163.163,0,0,1-.291,0l-.3-.465v.781a.173.173,0,1,1-.347,0V40.78a.171.171,0,0,1,.189-.163.207.207,0,0,1,.192.1l.416.678.416-.678a.2.2,0,0,1,.189-.1.171.171,0,0,1,.188.163ZM28,43.114c.476,0,.68-.2.68-.68V40.479c0-.476-.2-.679-.68-.679H24.628l-1.459,1.757-.054-.026.136-.6a.294.294,0,0,0-.068-.007.475.475,0,0,0-.477.494v.005a.482.482,0,0,0,.481.5.473.473,0,0,0,.476-.493v-.005a.489.489,0,0,0-.021-.144l.3-.234a.835.835,0,0,1,.088.374v.005a.82.82,0,0,1-.844.821.812.812,0,0,1-.841-.815v-.005a.819.819,0,0,1,.844-.821,1.2,1.2,0,0,1,.138.009l.187-.81H13.389c-.476,0-.68.2-.68.679v1.955c0,.476.2.68.68.68ZM17.254,41.858h-.7l-.11.262a.167.167,0,0,1-.323-.051.2.2,0,0,1,.02-.08l.554-1.249a.217.217,0,0,1,.212-.138.219.219,0,0,1,.214.138l.552,1.249a.2.2,0,0,1,.02.08.171.171,0,0,1-.33.051Zm-.569-.307h.44l-.221-.525Zm4.728-.448c0-.112-.08-.168-.228-.168H20.84v.335h.323c.155,0,.25-.049.25-.167m-6.389-.16h-.348V41.4h.355c.17,0,.267-.09.267-.224v-.005c0-.149-.1-.226-.274-.226m6.219.617h-.4v.348h.414c.155,0,.248-.054.248-.172s-.08-.177-.26-.177",
    transform: "translate(10.433 -32.346)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 224,
    height: 12,
    transform: "translate(44 15)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 224,
    height: 2,
    transform: "translate(44 39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 224,
    height: 2,
    transform: "translate(44 84)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 224,
    height: 2,
    transform: "translate(44 54)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 224,
    height: 2,
    transform: "translate(44 99)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 224,
    height: 2,
    transform: "translate(44 69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 224,
    height: 2,
    transform: "translate(44 114)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 224,
    height: 2,
    transform: "translate(44 129)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 224,
    height: 2,
    transform: "translate(44 144)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 16,
    height: 4,
    rx: 1,
    transform: "translate(49 6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 28,
    height: 4,
    rx: 1,
    transform: "translate(49 19)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 16,
    height: 4,
    rx: 1,
    transform: "translate(73 6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 16,
    height: 4,
    rx: 1,
    transform: "translate(97 6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 16,
    height: 4,
    rx: 1,
    transform: "translate(121 6)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8154 3697)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "f",
    x2: 24,
    transform: "translate(8165.5 -3673.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x2: 1,
    transform: "translate(8161.5 -3673.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8154 3704)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "f",
    x2: 24,
    transform: "translate(8165.5 -3673.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x2: 1,
    transform: "translate(8161.5 -3673.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8154 3711)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "f",
    x2: 24,
    transform: "translate(8165.5 -3673.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x2: 1,
    transform: "translate(8161.5 -3673.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8154 3718)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "f",
    x2: 24,
    transform: "translate(8165.5 -3673.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x2: 1,
    transform: "translate(8161.5 -3673.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8154 3725)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "f",
    x2: 24,
    transform: "translate(8165.5 -3673.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x2: 1,
    transform: "translate(8161.5 -3673.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8154 3732)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "f",
    x2: 24,
    transform: "translate(8165.5 -3673.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x2: 1,
    transform: "translate(8161.5 -3673.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8154 3739)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "f",
    x2: 24,
    transform: "translate(8165.5 -3673.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x2: 1,
    transform: "translate(8161.5 -3673.5)"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(256 4)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8013 3752)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(8123 -3696)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10,0,20,14H0Z",
    transform: "translate(8156 -3682) rotate(90)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoThumbnail);
export default __webpack_public_path__ + "static/media/videoThumbnail.09a8086cfb8ad0b69d63a6370598ee45.svg";
export { ForwardRef as ReactComponent };